import type { ReactNode } from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import { useAuthStore } from '../lib/auth.js';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { lang } = useParams();
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const hydrated = useAuthStore((s) => s.hydrated);

  if (!hydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500">Loading…</div>
    );
  }

  if (!user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/${lang}/auth/login?next=${encodeURIComponent(next)}`} replace />;
  }

  return <>{children}</>;
}
